/*
 * @Author: huguantao1@jd.com
 * @Date: 2025-06-06 17:02:30
 * @LastEditors: huguantao1@jd.com
 * @LastEditTime: 2025-07-07 21:49:56
 * @FilePath: /intl-pc-jdi-website-ssr/src/components/product/commonProductList.tsx
 * @Description: default
 */
"use client";
import { CommonProductListWrapper } from "@/styles/product";
import { JDIProductCardV2 } from "@/lib/jdiClientUtils";
import { getUserUUIDFromCookie } from "@/utils/userUtils";
import UKToast from "@/components/UKToast";
import { useTranslation } from "@/i18n/client";
type Props = {
    title?: string,
    data: any[],
    headerNav?: React.ReactNode
}

export default function CommonProductList ({title, data = [], headerNav = null}: Props) {
    const { t } = useTranslation()

    return <> {!!data?.length && <>
    {/* {headerNav} */}
    <CommonProductListWrapper>
        { title && <h2 className="title">{title}</h2>}
        <div className="product-card-wrapper">
            {/* { data.map((item: any, index: number)=> <Card key={index} data={item} />)} */}
            {data.map((item: any, index: number)=> {
              if(!item.content){
                return null
              }
                const productData = {
                    skuId: item.skuId,
                    skuImgKeyParams: {
                        imgUrlKey: item.content?.imageUrl,
                        width: 240,
                        height: 240,
                        domains: process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(","),
                      },
                    skuName: item.content?.wareName,
                    // imageUrl: item.content.imageUrl,
                    realPrice: item.content?.realPrice,
                    originalPrice: item.content?.originalPrice,
                    type: "2",
                    saleNum: item.content?.saleNum,
                    score: item.content?.commentScore,
                    shouldShowScore: true,
                    shouldShowCart: true,
                    promotions: item.content?.promotions || []
                }
                // return <>{item.content.originalPrice}</>
                return <JDIProductCardV2 productData={productData} key={item.skuId} />
            })}
        </div>
    </CommonProductListWrapper>
    </>}</>
}